export default __webpack_public_path__ + "static/article-how-travel-opens-your-mind-604cf3377fd6cb471903ec1de920a716.jpg";